import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-expandable-section',
    templateUrl: './expandable-section.component.html',
    styleUrls: ['./expandable-section.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [NgClass]
})
export class ExpandableSectionComponent {
    @Input() set initIsOpen(value) {
        // parse string to bool
        this.isOpen = value.toString() === 'true';
    }
    @Input() title;

    public isOpen = true;

	constructor(
	) {}

    toggle() {
        this.isOpen = !this.isOpen;
    }

}
